import api from '../services/api';
import { isAccessTokenValid } from './AuthController';

export const getAllScreeningLog = async () => {
    try {
        await isAccessTokenValid();
        const response = await api.get('/screening-log');
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};
